import { useMemo } from 'react';
import { ChoiceDrill } from './ChoiceDrill';
import { css, makeColorRound } from './color';
import type { DrillProps } from './meta';

export function ColorDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeColorRound(level, seed), [level, seed]);
  return (
    <ChoiceDrill
      questions={questions} seed={seed} onDone={onDone} className="color-drill" marks={false}
      choicesClass={(q) => (q.kind === 'odd' ? 'swatch-grid' : 'swatch-row')}
      info={(q) => ({ kind: q.kind })}
      render={(q) => (q.kind === 'mix' ? (
        <div className="color-q">
          <p className="lang-ask small-ask">두 물감을 {q.ratio[0] === q.ratio[1] ? '같은 양으로' : `${q.ratio[0]} : ${q.ratio[1]} 로`} 섞으면?</p>
          <div className="mix-row">
            <span className="color-swatch big" style={{ background: css(q.a) }} aria-label="물감 1" />
            {q.ratio[0] !== q.ratio[1] && <span className="mix-ratio">×{q.ratio[0]}</span>}
            <span className="mix-plus">+</span>
            <span className="color-swatch big" style={{ background: css(q.b) }} aria-label="물감 2" />
            {q.ratio[0] !== q.ratio[1] && <span className="mix-ratio">×{q.ratio[1]}</span>}
          </div>
        </div>
      ) : (
        <p className="lang-ask small-ask">색이 조금 다른 칸 하나는?</p>
      ))}
      renderChoice={(q, i) => <span className="color-swatch" style={{ background: css(q.swatches[i]) }} aria-label={`색 ${i + 1}`} />}
    />
  );
}
